export const windowInnerWidth = () => window.innerWidth;

// Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
export const bodyClientWidth = () => document.body.clientWidth;
